// @ts-nocheck
// Mappa il numero di candele di una lapide su un'intensità di alone (0..1) e la
// applica come CSS var `--candle-glow` sull'elemento del buco (.hole-spot).
// Di notte (vedi day-night.ts) l'alone viene rivelato e scalato così che le
// lapidi con più candele si vedano di più. Curva logaritmica per coerenza con
// il punteggio del catalogo backend (ln(1 + candleCount)).
import { mapState } from "./state";
import { flowerIconSvg } from "../utils/tribute-icons";

export const CANDLE_GLOW_CAP = 40;

export function candleGlowIntensity(count) {
  const n = Math.max(0, Number(count) || 0);
  if (n <= 0) return 0;
  return Math.min(1, Math.log1p(n) / Math.log1p(CANDLE_GLOW_CAP));
}

export function applyCandleGlow(el, count) {
  if (!el) return;
  el.style.setProperty("--candle-glow", String(candleGlowIntensity(count)));
}

// Aggiorna in tempo reale l'alone di una lapide quando cambia il conteggio
// candele (es. dopo che l'utente accende una candela dalla scheda memoriale).
export function updateGraveCandleCount(headstoneId, candleCount) {
  if (!headstoneId) return;
  let holeId = mapState.graveIdToHole.get(headstoneId);
  if (!holeId) {
    // Fallback per entry scritte fuori da indexHeadstone (raro).
    for (const [hid, data] of Object.entries(mapState.gravesData)) {
      if (data && data.id === headstoneId) {
        holeId = hid;
        break;
      }
    }
    if (!holeId) return;
    mapState.graveIdToHole.set(headstoneId, holeId);
  }
  const data = mapState.gravesData[holeId];
  if (data) data.candleCount = candleCount;
  applyCandleGlow(mapState.holeEls[holeId], candleCount);
}

export function updateGraveFlowerCount(headstoneId, flowerCount) {
  if (!headstoneId) return;
  let holeId = mapState.graveIdToHole.get(headstoneId);
  if (!holeId) {
    for (const [hid, data] of Object.entries(mapState.gravesData)) {
      if (data && data.id === headstoneId) {
        holeId = hid;
        break;
      }
    }
    if (!holeId) return;
    mapState.graveIdToHole.set(headstoneId, holeId);
  }
  const data = mapState.gravesData[holeId];
  if (data) data.flowerCount = flowerCount;
  const tomb = mapState.holeEls[holeId]?.querySelector(".tombstone");
  if (!tomb) return;
  let el = tomb.querySelector(".tomb-flower-gift");
  if (!flowerCount) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("div");
    el.className = "tomb-flower-gift";
    el.setAttribute("aria-hidden", "true");
    tomb.appendChild(el);
  }
  el.innerHTML = flowerIconSvg(14);
}
